<script setup>
import { useAuthStore } from "@/store/auth";
import { ref, onMounted } from "vue";
import routes from "@/router/routes";
import { useDisplay } from "vuetify/lib/framework.mjs";

import logoImage from "@/assets/images/logo_brunasso.png";
import { useNotifications } from "@/store/notification";
import { useAppStore } from "@/store/app";
import { computed } from "vue";

const versions = import("@/assets/version.json")
const version = ref({})

const display = useDisplay();

const authStore = useAuthStore();
const notifiche = useNotifications()
const appStore = useAppStore();

const counterEsterEgg = ref(0);

const stepsEater = [10, 20, 40, 60, 80, 100, 120, 140]

const esterColor = ["purple","brown", "accent", "error", "warning", "info", "success", "primary"];
// All animals 
const esterIcon = ["mdi-egg-easter","mdi-duck", "mdi-turtle", "mdi-horse", "mdi-panda",  "mdi-penguin", "mdi-rabbit", "mdi-snail"];


const colorIconVersion = computed(() => {

  let val = {
    icon: 'mdi-tag',
    color: 'primary'
  }

  stepsEater.forEach((step, index) => {
    if (counterEsterEgg.value >= step) {
      val.icon = esterIcon[index]
      val.color = esterColor[index]
    }
  })

  

  return val
});

function moreEaster() {
  counterEsterEgg.value++;
  localStorage.setItem("counterEsterEgg-mb", JSON.stringify({'counter':counterEsterEgg.value}));

  if (counterEsterEgg.value == 10) {
    notifiche.newNotication("info", 10000, "Non dovresti tornare al lavoro? 😜", "mdi-egg-easter");
  }
}

const drawer = ref(true);

function showRoute(route) {
  // console.log(route)

  if (route.meta?.hidden) {
    ////console.log("La route è nascosta")
    return false;
  }

  // Se auth richiesta
  if (route.meta?.authRequired) {
    // console.log("La route richiede auth")

    if (!authStore.isAuthenticated) {
      ////console.log("L'utente non è autenticato")
      return false;
    }

    // Se gruppi richiesti
    if (route.meta?.groupsRequired) {
      // console.log("La route richide alcuni gruppi",route.meta?.groupsRequired)
      // console.log("L'utente ha i seguenti gruppi",authStore.user.roles)

      let groupsRequired = route.meta.groupsRequired;

      let hasGroupsRequired = false;

      for (let i = 0; i < groupsRequired.length; i++) {
        // console.log("Contollo il gruppo",groupsRequired[i])

        if (authStore.user.roles.includes(groupsRequired[i])) {
          // console.log("L'utente ha i gruppi richiesti")
          hasGroupsRequired = true;
          break;
        }
      }

      // console.log("hasGroupsRequired",hasGroupsRequired)
      return hasGroupsRequired;
    }

    // console.log("La route non richiede gruppi")
    // console.log("L'utente è autenticato",true)
    return true;
  }

  return true;
}




function checkVersion() {

  console.log(version.value)

  let localStorageName = "version-mobili-brunasso-" + version.value.env.slug;

  var storedVersion = localStorage.getItem(localStorageName);
  try {
    storedVersion = JSON.parse(storedVersion);
  } catch (e) {
    storedVersion = null;
  }
  if (storedVersion) {
    if (storedVersion.commit.short == version.value.commit.short) {
      return;
    }
    notifiche.newNotication("primary", 10000, "Il sito è stato aggiornato dall'ultima visita", "mdi-arrow-up-thick");
  }


  try {
    localStorage.setItem(localStorageName, JSON.stringify(version.value));
  } catch (e) {
    console.log(e);
  }
}


onMounted(async () => {
  version.value = JSON.parse(JSON.stringify(await versions))

  console.warn("mounted navbar")

  if(counterEsterEgg.value > 1) {
    counterEsterEgg.value = colorIconVersion.value - 2
  } 

  checkVersion();

  //Check ester egg

  let localStorageValue = localStorage.getItem("counterEsterEgg-mb");

  try {
    localStorageValue = JSON.parse(localStorageValue);
    localStorageValue = localStorageValue.counter;
  } catch (e) {
    localStorageValue = null;
  }

  if (localStorageValue) {
    counterEsterEgg.value = localStorageValue;
  }


})


</script>

<template>
  <v-app-bar color="primary" style="user-select: none; -webkit-user-drag: none;" class="d-flex justify-space-between">
    <div  class="pl-5">
      <v-btn @click="drawer = !drawer" icon v-if="display.smAndDown">
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </div>



    <v-app-bar-title>
      <v-img :src="logoImage" height="2em"></v-img>
    </v-app-bar-title>


    <div class="mr-5">
      <v-menu v-if="authStore.user.name != null">
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props" icon="mdi-account-circle" variant="tonal" />
        </template>
        <v-list>
          <v-list-item :title="authStore.user?.name" subtitle="Username" />
          <v-list-item :title="authStore.user.roles.join(', ')"  subtitle="Gruppi" />
          
          <v-list-item class="mt-3">
            <v-btn @click="authStore.logout()" variant="outlined" append-icon="mdi-logout" color="error"> Esci </v-btn>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn to="/login"  color="success" v-else> Login </v-btn>
    </div>
  </v-app-bar>
  <v-navigation-drawer v-model="drawer" :permanent="!display.sm">
    <v-list>
      <span v-for="route in routes" :key="route.name">
        <v-list-item :to="route.path" :appendIcon="route.meta.icon" v-if="showRoute(route)" color="primary">
          {{ route.name }}
        </v-list-item>
      </span>
    </v-list>

    <template v-slot:append>

      <v-divider />
      <div class="text-caption py-2 d-flex justify-end pr-2">

        <v-btn variant="tonal" density="compact" class="text-caption ml-1" prepend-icon="mdi-rocket-launch-outline" color="primary" >
        {{ appStore.environment }}
      </v-btn>
      <v-btn variant="tonal" density="compact" class="text-caption ml-1" :prepend-icon="colorIconVersion.icon" :color="colorIconVersion.color" @click="moreEaster">
        {{ version?.commit?.tag || version?.commit?.short }}
      </v-btn>
      </div>
     
    </template>
  </v-navigation-drawer>
</template>


<style scoped>
.text-append {
  font-size: 0.7em;
}
</style>
